var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1169.28 463.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        isolation: isolate;\n      }\n\n      .cls-3, .cls-4 {\n        fill: #f28100;\n      }\n\n      .cls-4, .cls-5 {\n        mix-blend-mode: multiply;\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-7 {\n        fill: url(#radial-gradient);\n        mix-blend-mode: color-burn;\n      }\n\n      .cls-8 {\n        mix-blend-mode: hard-light;\n      }\n\n      .cls-5 {\n        opacity: .5;\n      }\n    "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 589.97,
    cy: 191.98,
    fx: 589.97,
    fy: 191.98,
    r: 718.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#9d9d9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#262626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 380.77,
    y1: -57.33,
    x2: 799.17,
    y2: 441.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#919191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#b8b8b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#d7d7d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#ededed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#fafafa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#e9e9e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#cecece"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#aaa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#a3a3a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#c2c2c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#909090"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M964.99,310.49H214.95c-58.03,0-105.07-47.04-105.07-105.07h0c0-58.03,47.04-105.07,105.07-105.07h750.04c58.03,0,105.07,47.04,105.07,105.07h0c0,58.03-47.04,105.07-105.07,105.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M964.99,310.49H214.95c-58.03,0-105.07-47.04-105.07-105.07h0c0-58.03,47.04-105.07,105.07-105.07h750.04c58.03,0,105.07,47.04,105.07,105.07h0c0,58.03-47.04,105.07-105.07,105.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M964.99,310.49H214.95c-58.03,0-105.07-47.04-105.07-105.07h0c0-58.03,47.04-105.07,105.07-105.07h750.04c58.03,0,105.07,47.04,105.07,105.07h0c0,58.03-47.04,105.07-105.07,105.07Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 109.88,
    y: 86.91,
    width: 960.18,
    height: 210.15,
    rx: 105.07,
    ry: 105.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 109.88,
    y: 86.91,
    width: 960.18,
    height: 210.15,
    rx: 105.07,
    ry: 105.07
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M962.06,278.3H217.89c-47.6,0-86.32-38.72-86.32-86.32s38.72-86.32,86.32-86.32h744.17c47.6,0,86.32,38.72,86.32,86.32s-38.72,86.32-86.32,86.32ZM217.89,110.17c-45.11,0-81.81,36.7-81.81,81.81s36.7,81.81,81.81,81.81h744.17c45.11,0,81.81-36.7,81.81-81.81s-36.7-81.81-81.81-81.81H217.89Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M248.9,215.82h-14.15v-52.89h21.39c13.46,0,20.92,7.93,20.92,18.74,0,7-3.34,12.52-9.64,15.4l10.97,18.74h-15.32l-9.33-16.57h-4.82v16.57ZM255.44,188.44c4.82,0,7.39-2.41,7.39-6.77s-2.57-6.77-7.39-6.77h-6.53v13.53h6.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M289.74,162.93h37.1v11.9h-22.94v8.71h19.13v11.28h-19.13v9.1h24.03v11.9h-38.19v-52.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M374.98,197.23h-10.5v-10.89h23.1v22.87c-4.9,4.04-11.28,7.31-23.02,7.31-15.56,0-28.47-11.2-28.47-27.14s12.91-27.06,28.15-27.06c9.33,0,16.64,3.5,21.23,9.41l-9.88,8.55c-2.64-3.42-6.38-5.68-11.67-5.68-8.63,0-13.38,6.46-13.38,14.78s4.82,15.24,14.15,15.24c5.13,0,8.01-1.01,10.27-2.1v-5.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M399.64,162.93h14.15v52.89h-14.15v-52.89ZM401.9,159.66l3.11-14.15h14.62l-7.39,14.15h-10.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M423.68,206.8l10.27-7.7c2.57,3.19,5.76,5.75,11.04,5.75,4.2,0,6.69-1.24,6.69-4.2,0-2.26-1.71-3.34-5.21-4.51l-6.22-2.1c-7.7-2.57-13.14-7.23-13.14-15.94,0-10.42,8.63-15.79,18.04-15.79s14.93,3.34,18.04,7l-8.09,8.48c-2.18-2.26-4.98-3.81-9.18-3.81-3.42,0-5.13,1.56-5.13,3.66s1.17,3.03,3.73,3.89l7,2.33c10.58,3.5,14.15,8.56,14.15,16.02,0,9.72-6.07,16.72-20.07,16.72-11.9,0-18.67-5.44-21.93-9.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M486.06,174.83h-14v-11.9h42.15v11.9h-14v40.99h-14.15v-40.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M539.41,215.82h-14.15v-52.89h21.39c13.46,0,20.92,7.93,20.92,18.74,0,7-3.34,12.52-9.64,15.4l10.97,18.74h-15.32l-9.33-16.57h-4.82v16.57ZM545.95,188.44c4.82,0,7.39-2.41,7.39-6.77s-2.57-6.77-7.39-6.77h-6.53v13.53h6.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M610.89,209.44h-18.43l-2.64,6.38h-13.84l25.74-53.82c.23-.54.7-.54.93,0l25.67,53.82h-14.62l-2.8-6.38ZM596.81,199.17h9.57l-4.82-11.2-4.74,11.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M641.31,174.83h-14v-11.9h42.15v11.9h-14v40.99h-14.15v-40.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M680.51,162.93h37.1v11.9h-22.94v8.71h19.13v11.28h-19.13v9.1h24.03v11.9h-38.19v-52.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M784.34,209.44h-18.43l-2.64,6.38h-13.84l25.74-53.82c.23-.54.7-.54.93,0l25.67,53.82h-14.62l-2.8-6.38ZM770.26,199.17h9.57l-4.82-11.2-4.74,11.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M837.93,225.46h-11.67v-9.49c-12.6-2.49-22.55-12.76-22.55-26.6,0-15.94,13.14-27.06,28.39-27.06s28.39,11.12,28.39,27.06c0,13.84-9.96,24.11-22.55,26.6v9.49ZM826.27,194.12h11.67v9.41c5.21-2.1,8.09-7.31,8.09-14.16,0-8.32-5.06-14.78-13.92-14.78s-13.92,6.46-13.92,14.78c0,6.84,2.88,12.06,8.09,14.16v-9.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M871.22,195.36v-32.43h14.15v32.28c0,5.99,2.8,9.41,8.79,9.41s8.79-3.42,8.79-9.41v-32.28h14.15v32.43c0,14.23-9.72,21.23-22.94,21.23s-22.94-7-22.94-21.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M930.73,162.93h14.15v52.89h-14.15v-52.89ZM932.98,159.66l3.11-14.15h14.62l-7.39,14.15h-10.34Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/LogoWhite.9d2661899c6cff4d1858c4dec7b3a305.svg";
export { ForwardRef as ReactComponent };